import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import DefaultSelect from '../../../shared/default-select/components/default-select';
import DefaultInput from '../../../shared/default-input/components/default-input';
import linkCreatorConstants from '../constants/link-creator-constants';
import constants from '../../../../common/constants';
import { setCampaign, setLanguage, setAnchor } from '../actions/link-creator-actions';

class LinkCreatorSelectors extends Component {
  componentDidMount() {
    const { campaigns, setCampaign, setLanguage, change } = this.props;

    if (campaigns && campaigns[0]) {
      setCampaign(campaigns[0]);
      change('campaign', campaigns[0].reference_code_id);
    }

    const languages = Object.assign([], _.values(constants.languages));

    if (languages && languages[0]) {
      setLanguage(languages[0].value);
      change('language', languages[0].value);
    }
  }

  handleCampaignChange(e) {
    const { campaigns, setCampaign } = this.props;

    const campaign = _.find(campaigns, item => {
      return item.reference_code_id.toString() === e.target.value.toString();
    });

    if (campaign) {
      setCampaign(campaign);
    }
  }

  handleLanguageChange(e) {
    const { setLanguage } = this.props;

    setLanguage(e.target.value);
  }

  handleAnchorInputChange(e) {
    const { setAnchor } = this.props;

    setAnchor(e.target.value);
  }

  render() {
    const { t } = this.context;
    const { campaigns } = this.props;
    const languages = Object.assign([], _.values(constants.languages));

    return (
      <div className="link-creator-selectors-container">
        <div className="row">
          <form noValidate>
            <div className="col-md-6 m-t-20">
              <Field
                name={'campaign'}
                inputName={'campaign'}
                label={'BANNERS.SELECT_CAMPAIGN'}
                options={campaigns}
                optionLabel={'link_name'}
                customLabel={'CAMPAIGNS.MOBILE_TRAFFIC'}
                optionValue={'reference_code_id'}
                component={DefaultSelect}
                onChange={e => this.handleCampaignChange(e)}
              />
            </div>
            <div className="col-md-6 m-t-20">
              <Field
                name={'language'}
                inputName={'language'}
                label={'HEADER.LANGUAGE_DROPDOWN_LABEL'}
                options={languages}
                optionLabel={'text'}
                optionValue={'value'}
                component={DefaultSelect}
                onChange={e => this.handleLanguageChange(e)}
              />
            </div>
            <div className="col-md-12 m-t-20 text-center">
              <label className="font-size-24">{t('LINK_CREATOR.GET_CODE')}</label>
            </div>
            <div className="display-flex-center col-md-12">
              <div className="col-md-6 col-sm-12">
                <Field
                  name={'anchor'}
                  inputName={'anchor'}
                  label={'LINK_CREATOR.ANCHOR_TEXT'}
                  component={DefaultInput}
                  onChange={e => {
                    this.handleAnchorInputChange(e);
                  }}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

LinkCreatorSelectors.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  campaigns: state.campaignsReducer.campaigns,
});

const mapDispatchToProps = dispatch => ({
  setCampaign: campaign => {
    dispatch(setCampaign(campaign));
  },
  setLanguage: lang => {
    dispatch(setLanguage(lang));
  },
  setAnchor: text => {
    dispatch(setAnchor(text));
  },
});

LinkCreatorSelectors = reduxForm({
  form: linkCreatorConstants.link_creator_form,
})(LinkCreatorSelectors);

export default connect(mapStateToProps, mapDispatchToProps)(LinkCreatorSelectors);



// WEBPACK FOOTER //
// ./src/app/main/link-creator/components/link-creator-selectors.js